/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Guide_Cta_TitleInputs */

const en_directory_guide_cta_title = /** @type {(inputs: Directory_Guide_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to submit?`)
};

const zh_directory_guide_cta_title = /** @type {(inputs: Directory_Guide_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备好提交了吗？`)
};

/**
* | output |
* | --- |
* | "Ready to submit?" |
*
* @param {Directory_Guide_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_guide_cta_title = /** @type {((inputs?: Directory_Guide_Cta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Guide_Cta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_guide_cta_title(inputs)
	return zh_directory_guide_cta_title(inputs)
});
export { directory_guide_cta_title as "directory.guide.cta_title" }